import { React, useEffect } from "react"
import { HashLink as Link } from "react-router-hash-link"
import { Form, Input } from "antd"
import { useDispatch } from "react-redux"
import {
  updateUserDetailsRedux,
  setConnectedWallet,
  setActiveMenu
} from "../../redux/actions"
import swal from "sweetalert"
import axios from "axios"
import { BaseUrl } from "../utils/config"

// widget

// Styles
// import "../../assets/css/marketplace.css";
// import "./styles/newstyles.css";
// import "./styles/landing.css";
import "./styles/ecosystem.css"

// Images
import Nlogo from "./images/Eco/Nitro_NLogo.png"
import nesting from "./images/Eco/nesting.jpeg"
import preminer from "./images/Eco/preminer.jpeg"
import marketplace from "./images/Eco/marketplace.jpeg"
import anoop from "./images/Eco/1.png"
import avinash from "./images/Eco/2.png"
import Karthik from "./images/Eco/3.png"
import praveen from "./images/Eco/4.png"
import ball from "./images/Eco/3DBalls.png"
import cointelegraph from "./images/cointelegraph.png"

//partners
import avax from "./images/partners/avaxfull.svg"
import beefy from "./images/partners/beefy-cropped.svg"
// import cointelegraph from "./images/partners/Cointelegraphb.svg";
import pangolin from "./images/partners/pangolin.svg"
import techmahindra from "./images/partners/techwhite.png"
import { Images } from "../../Shared/images"
import { NavLink } from "../menu/header"
import { useNavigate } from "@reach/router"
import { isNestEnabled } from "../../utils/config"
// import { Link, useNavigate, useLocation } from "@reach/router";

// import { Link } from "react-router-dom";

function EcosystemNew() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [form] = Form.useForm()
  const submitContactForm = values => {
    const Fobj = {
      first_name: values.fName,
      last_name: values.lName,
      email: values.email,
      comment: values.comment
    }
    if (
      values.fName == null ||
      values.fName == "" ||
      values.lName == null ||
      values.email == null ||
      values.email == "" ||
      values.lName == "" ||
      values.comment == null ||
      values.comment == ""
    ) {
      swal({
        title: "",
        text: "Please enter the Credentials",
        icon: "error"
      })
    } else {
      axios
        .post(`${BaseUrl}/contactus`, Fobj)
        .then(response => {
          if (response) {
            // "Your Federal Account Created Successfully"
            // message.success(`Congratulations  Your Federal Account Created Successfully`,3)
            swal({
              title: "Success!",
              text: "Request submitted successfully, we will review and revert.",
              icon: "success"
            })
            // setTimeout(() => { navigate("/login"); }, 3000)
            form.resetFields()
          } else {
            swal({
              title: "Invalid Credentials",
              text: "Invalid credentials. Please try again.",
              icon: "error"
            })
          }
        })
        .catch(error => {
          if (error?.response?.status === 401) {
            dispatch(updateUserDetailsRedux({}))
            dispatch(setConnectedWallet(""))
            localStorage.clear()
            navigate("/login")
          }
        })
    }
  }

  useEffect(() => {
    document.title = "Nitro's Ecosystem"
    return () => {
      document.title = "Nitro Network"
    }
  }, [])

  return (
    <div>
      {/* Hero Image Section */}
      <div className=" hero">
        <div className="hero-container">
          <div className="hero-text">
            <h1>Build telecom networks with us</h1>

            <h2>
              <span className="green">Own. </span>
              <span className="sky">Operate. </span>
              <span className="green">Earn. </span>
            </h2>

            <p>
              Nitro's decentralised networks open endless possibilities for
              participants to build, grow and monetize from the network
              perpetually.{" "}
            </p>

            <div className="btns-nester">
              <a
                href="https://buy.nitro.network/buy-nfm"
                aria-label="Buy NFM"
                className="btn-cta sky">
                Buy NFM
              </a>
              {/* <Link to="https://nitro.network" className="btn-cta sky">
                Buy NFM
              </Link> */}
              {/* <a href="#" className="btn-ncta nl-2 green">
                Miner
              </a> */}
            </div>
          </div>

          <div className="hero-image"></div>
        </div>
        <div className="arrow">
          <Link smooth to="#ecosystem" aria-label="Down arrow">
            <img
              src="https://img.icons8.com/ios-filled/54/ffffff/down--v2.png"
              className="slide-bottom"
              alt="Scroll down arrow"
            />
          </Link>
          {/* <a href="#marketplace"></a> */}
        </div>
      </div>

      {/* Trending Section */}
      <div className="trending">
        <div className="trending-container">
          <h3>Trending</h3>
          {/* <Slider {...settings}> */}
          <div className="trending-box-container">
            <div>
              <h4>
                NFM Bundles <small>(coming soon)</small>{" "}
              </h4>
              <p>
                NFMs (Non-Fungible Miners) are Nitro’s unique
                utility-cum-collectible NFTs which unlock rewards for
                participants on the network. These sought after NFMs are now
                available in Combo Packs at exciting discounts. Get more for
                less!
              </p>
              {/* <a
                  href="https://ecosystem.nitro.network/combo"
                  className="btn-cta learn-more"
                >
                  Learn More
                </a> */}
            </div>
            <div>
              <h4>Genesis Node</h4>
              <p>
                This is Nitro’s exclusive legacy program to reward long term
                NCash token holders for their support. Amongst other privileges
                genesis nodes are entitled to rewards for the next 50 years.
              </p>
              {/* <a
                  href="https://staking.nitro.network/"
                  className="btn-cta learn-more"
                >
                  Learn More
                </a> */}
            </div>
            <div>
              <h4>Nester</h4>
              <p>
                Learn how rewarding it is to host Nitro Network as a Nester.
                Nitro has created a unique 1:1 grid which places 1 nest in 1 sq.
                km overcoming roadblocks to network congestion and inequitable
                distribution of rewards. Become a nester in a few simple steps
                and earn rewards effortlessly from your location.
              </p>
              {/* <a
                  href="https://ecosystem.nitro.network/nest"
                  className="btn-cta learn-more"
                >
                  Learn More
                </a> */}
            </div>

            <div>
              <h4>Super Nest</h4>
              <p>
                Lead the nesting initiative as a Super Nest in your area or
                location. All you need to have is super networking abilities,
                some solid contacts and the right aptitude. Nitro will
                collaborate with you in this initiative through which you will
                enable smart building and smart system management of daily
                utilities in your area.
              </p>
              {/* <a
                  href="https://ecosystem.nitro.network/supernest"
                  className="btn-cta learn-more"
                >
                  Learn More
                </a> */}
            </div>
          </div>
          {/* </Slider> */}
        </div>
      </div>

      <div className="video-section-page" style={{ display: "none" }}>
        {/* <!-- <div className="video-back">
          <img src="./images/header.jpeg" alt="" />
        </div> --> */}
        <div className="text">
          <h1>
            Digital Mining and You: <br />A New Phenomenon Is Here
          </h1>
        </div>
        <div className="arrow">
          <Link smooth to="#ecosystem">
            <img
              src="https://img.icons8.com/ios-filled/54/ffffff/down--v2.png"
              className="slide-bottom"
            />
          </Link>
          {/* <a href="#marketplace"></a> */}
        </div>
      </div>

      {/* <!-- BIGGER BETTER ECOSYTEM --> */}
      <div className="ecosystem" id="ecosystem">
        <div className="conatiner">
          <h1 className="uppercase text-center first">
            CREATING A <span className="green">BIGGER, BETTER</span> ECOSYSTEM
          </h1>
          <p className="first-p">
            Nitro Network’s Non-Fungible Miners, or NFMs, are the next evolution
            in NFT utility. NFMs combine the unique artwork and ownership
            principles of NFTs with the reward-generating utility of the DeFi
            industry. While most traditional mining methods require expensive,
            inefficient hardware, NFMs generate rewards for their owners in the
            form of Nitro’s native token, $NCash, without the need for
            additional equipment and expenses.
          </p>
          <div className="text-center">
            <a
              href="https://nitronetwork.medium.com/"
              className="learn-more-btn"
              target="_blank"
              aria-label="Medium">
              Learn More
            </a>
          </div>

          {/* <!-- MULTICOIN , MINING, COMMUNICATION --> */}
          <div className="multicoin-section">
            {/* Temporarily removed */}
            <div
              // href="#."
              className="multi-box">
              <NavLink to="/marketplace">
                <div className="multi-img" id="marketplace-card">
                  <img src={marketplace} alt="" />
                  {/* <h1 id="coming-soon">Coming soon</h1> */}
                </div>
              </NavLink>
              <h2 className="mt-5px">Marketplace</h2>

              {/* <!-- <h2>MULTICOIN MINING</h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                sodales ultricies ante, ut faucibus ligula rutrum fermentum. Sed
                eu pharetra tortor. Nam vitae cursus mi, id laoreet dolor
              </p> --> */}
            </div>
            {isNestEnabled && (
              <a href="/nest" className="multi-box">
                <div className="multi-img">
                  <img src={nesting} alt="" />
                </div>
                <h2>Nesting</h2>
              </a>
            )}
            <a
              href="https://staking.nitro.network"
              className="multi-box"
              target="_blank">
              <div className="multi-img">
                <img src={Images.staking} alt="" />
              </div>
              <h2>Staking</h2>
              {/* <!-- <h2>COMMUNICATION NETWORK</h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                sodales ultricies ante, ut faucibus ligula rutrum fermentum. Sed
                eu pharetra tortor. Nam vitae cursus mi, id laoreet dolor
              </p> --> */}
            </a>

            <a
              href="https://swap.nitro.network"
              className="multi-box"
              target="_blank">
              <div className="multi-img">
                <img src={Images.swapping} alt="" />
              </div>
              <h2>Swapping</h2>
            </a>
            <a
              href="/myaccount/pendingpayments"
              className="multi-box"
              onClick={() => dispatch(setActiveMenu("NFM"))}>
              <div className="multi-img">
                <img src={preminer} alt="" />
              </div>
              <h2>PRE-MINER PAYMENT</h2>
            </a>
          </div>

          <br />
          <br />
          <br />

          {/* <!-- TEAM --> */}
          <h1 className="executive text-center">EXECUTIVE TEAM</h1>

          {/* <!-- PROFILE CONTAINER --> */}
          <div className="profile">
            <div className="profile-container">
              <div className="profile-one">
                <div className="profile-pic">
                  <img src={anoop} alt="" />
                  <h3>Anoop Vootkuri</h3>
                  <p>Chief Executive Officer</p>
                </div>
              </div>
              <div className="profile-one">
                <div className="profile-pic">
                  <img src={avinash} alt="" />
                  <h3>Avinash Pitti</h3>
                  <p>Chief Technical Officer</p>
                </div>
              </div>
              <div className="profile-one">
                <div className="profile-pic">
                  <img src={Karthik} alt="" />
                  <h3>Karthik Kalluri</h3>
                  <p>Chief Operating Officer</p>
                </div>
              </div>
              <div className="profile-one">
                <div className="profile-pic">
                  <img src={praveen} alt="" />
                  <h3>Praveen Thakur</h3>
                  <p>Chief Product Officer</p>
                </div>
              </div>
            </div>
          </div>

          <div className="our-partners">
            <div className="partners-container">
              <h2 className="uppercase">Our Partners</h2>

              <div className="partners-images">
                <a href="https://cointelegraph.com/" target="_blank">
                  <img src={cointelegraph} alt="Coin Telegraph" />
                </a>

                <a href="https://www.avax.network/" target="_blank">
                  <img src={avax} alt="aValanche" />
                </a>

                <a href="https://pangolin.exchange/" target="_blank">
                  <img src={pangolin} alt="Pangolin" />
                </a>

                <a href="https://beefy.finance/" target="_blank">
                  <img src={beefy} alt="Befy" />
                </a>

                <a
                  href="https://www.techmahindra.com/en-in/?f=3840645508"
                  target="_blank">
                  <img src={techmahindra} alt="Tech mahindra" />
                </a>
              </div>
            </div>
          </div>
          <div className="balls">
            <img src={ball} alt="" />
          </div>
        </div>
      </div>

      <div className="media-mentions">
        <div className="media-box text-center">
          <h2>MEDIA MENTIONS</h2>
          <div className="media-links">
            <a
              target="_blank"
              className="media-link"
              id="media-mention-ctg"
              href="https://cointelegraph.com/news/cointelegraph-partners-with-nitro-network-to-bring-digital-mining-and-decentralized-internet-to-the-masses">
              <img src={cointelegraph} alt="Coin telegraph" />
            </a>
            <a
              target="_blank"
              className="media-link"
              id="media-mention-io"
              href="https://www.investorsobserver.com/news/crypto-update/amp/is-nitro-network-ncash-a-good-investment-sunday">
              <img src={Images.investorObserver} alt="Investor Observer" />
            </a>
            <a
              target="_blank"
              className="media-link"
              href="https://finance.yahoo.com/news/nucleus-vision-rebrands-itself-nitro-103300661.html">
              <img src={Images.yahooFinance} alt="Yahoo Finance" />
            </a>
          </div>
          <h2>&amp; MANY MORE</h2>
        </div>
        {/* <!-- BORDER RADIAL --> */}
        {/* <div className="border-radial"></div> */}
      </div>

      {/* <!-- EXPLORE ECOSYSTEM -->
      <!-- <div className="explore-ecosystem">
        <div className="content-bottom">
          <div className="content">
            <div className="text-content">
              <h1>EXPLORE THE ECOSYSTEM</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                sodales ultricies ante, ut faucibus ligula rutrum fermentum. Sed
                eu pharetra tortor. Nam vitae cursus mi, id laoreet dolor. Nam
                scelerisque nunc eu tellus porta, vitae vehicula metus pharetra.
                Etiam dapibus lectus in est dictum commodo. Pellentesque
                habitant morbi tristique senectus et netus et malesuada fames ac
                turpis egestas. Nulla ac sodales libero. Vivamus volutpat
                fringilla enim nec fringilla. Proin lacinia arcu justo, quis
                laoreet enim accumsan in. Vivamus at turpis ipsum. Aliquam lacus
                dolor, pretium quis volutpat nec, congue sed odio. Integer
                venenatis ac sem non vulputate.
              </p>

              <div className="text-center">
                <a
                  href="https://ecosystem.nitro.network/"
                  className="learn-more-btn"
                  >Check it out</a
                >
              </div>
            </div>

            <div className="image-content">
              <img src="./images/Earth2.png" alt="" />
            </div>
          </div>
        </div>
      </div> --> */}

      {/* <!-- CONTACT US --> */}
      <div className="contact-section">
        <div className="contact">
          <div className="image-logo">
            <img src={Nlogo} alt="" />
          </div>
          <div className="form-side">
            <h1>Contact Us</h1>
            <Form
              name="contactForm"
              id="contact_form"
              autoComplete="off"
              form={form}
              onFinish={submitContactForm}>
              {/* <form action=""> */}
              <div className="half-field">
                <div className="form-field">
                  <Form.Item
                    name="fName"
                    rules={[
                      {
                        required: true,
                        message: "First Name is required."
                      }
                    ]}>
                    <Input type="text" id="fname" placeholder="First Name" />
                  </Form.Item>
                  {/* <input type="text" id="fname" placeholder="First Name" /> */}
                </div>
                <div className="form-field">
                  <Form.Item
                    name="lName"
                    rules={[
                      {
                        required: true,
                        message: "Last Name is required."
                      }
                    ]}>
                    <Input type="text" id="lname" placeholder="Last Name" />
                  </Form.Item>
                  {/* <input type="text" id="lname" placeholder="Last Name" /> */}
                </div>
              </div>

              <div className="form-field ">
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Email is required."
                    },
                    {
                      type: "email",
                      message: "The email is not valid."
                    }
                  ]}>
                  <Input type="text" id="email" placeholder="Email Address" />
                </Form.Item>
              </div>

              <div className="form-field margin-0-after-error">
                <Form.Item
                  name="comment"
                  rules={[
                    {
                      required: true,
                      message: "Comment is required."
                    }
                  ]}>
                  <textarea
                    id="comment"
                    cols="30"
                    rows="5"
                    placeholder="Comment"></textarea>
                </Form.Item>
              </div>
              <div className="submit-btn-eco">
                <button
                  type="submit"
                  className="learn-more-btn w-100 uppercase"
                  style={{
                    border: "none"
                  }}>
                  Send Message
                </button>
                {/* <a href="#" className="learn-more-btn w-100 uppercase">
                  Send MEssage
                </a> */}
              </div>
              {/* </form> */}
            </Form>
          </div>
        </div>
      </div>

      {/* Footer */}
      {/* <Footer /> */}
    </div>
  )
}

export default EcosystemNew
